import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import user from "./modules/user";
import line from "./modules/line";
import pol from "./modules/pol";
import setting from "./modules/setting";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    drawer: true
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_DRAWER(state, _drawer) {
      state.drawer = _drawer;
    }
  },
  modules: {
    auth,
    user,
    line,
    pol,
    setting
  }
});
